import { render, staticRenderFns } from "./GroupedNeedCard.vue?vue&type=template&id=bb5c8808&"
import script from "./GroupedNeedCard.vue?vue&type=script&lang=js&"
export * from "./GroupedNeedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroupedNeedCard.vue"
export default component.exports